export default __webpack_public_path__ + "static/media/clear-file.55cbd762.svg";